<template>
  <!-- <DynamicZoom /> -->
  <router-view />
</template>

<script>
import { defineComponent } from 'vue'
import { Platform } from 'quasar'

export default defineComponent({
  name: 'App',
  beforeMount: () => {
    document.querySelector('body').classList.add(`platform-${Platform.is.platform}`)
    document.querySelector('body').classList.add(`agent-${Platform.is.name}`)
  },
})
</script>

<style lang="sass">
:root
  --zoom: 0.3
  --calculated-full-height: calc(100vh / var(--zoom))
  @media (min-width: 551px) and (max-width: 700px)
    --zoom: 0.4
    --calculated-full-height: calc(100vh / var(--zoom))
  @media (min-width: 701px) and (max-width: 820px)
    --zoom: 0.5
    --calculated-full-height: calc(100vh / var(--zoom))
  @media (min-width: 821px) and (max-width: 960px)
    --zoom: 0.6
    --calculated-full-height: calc(100vh / var(--zoom))
  @media (min-width: 961px) and (max-width: 1300px)
    --zoom: 0.63
    --calculated-full-height: calc(100vh / var(--zoom))
  @media (min-width: 1301px) and (max-width: 1440px)
    --zoom: 0.8
    --calculated-full-height: calc(100vh / var(--zoom))
  @media (min-width: 1441px) and (max-width: 1920px)
    --zoom: 0.9
    --calculated-full-height: calc(100vh / var(--zoom))
  @media (min-width: 1921px)
    --zoom: 1
    --calculated-full-height: calc(100vh / var(--zoom))


// [id^="q-portal--menu--"] [class^='q-virtual-scroll__'], [id^="q-portal--menu--"] .BaseActionMenu__main,
#q-app, #q-notify, [id^='q-portal--dialog--'], .user-profile, .dynamic-zoom, [id^="q-portal--menu--"] .q-date, [id^='q-portal--tooltip--'] > div > *
  zoom: var(--zoom)
</style>
